<template>
    <div class="vehica-menu-desktop-login-register-link">
        <div class="vehica-menu-item-depth-0">
            <a href="" @click.prevent="toggleMenu">
                <span class="vehica-menu-desktop-login-register-link__user-icon"><span class="vehica-menu-item-depth-0"><i class="far fa-user"></i></span></span>
                My Profile
            </a>
        </div>
        <div class="vehica-desktop-user-menu" v-show="showmenu">
            <div class="vehica-desktop-user-menu__inner">
                <div class="vehica-desktop-user-menu__top">
                    <div class="vehica-desktop-user-menu__top__info">
                        <div class="vehica-desktop-user-menu__name">
                            <a href="/account">
                                {{username}}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="vehica-desktop-user-menu__menu-links">
                    <a href="/sell">
                        <i class="fas fa-list"></i>My Listings
                    </a>
                    <!--<a href="/account/messages">
                        <i class="fas fa-comments"></i>Messages
                    </a>-->
                    <a href="/search?likes=true">
                        <i class="fas fa-star"></i>Likes
                        <span class="vehica-desktop-user-menu__menu-links__count">
                            <span>{{likes}}</span>
                        </span>
                    </a>
                    <a href="/account/my-profile">
                        <i class="fas fa-gear"></i>Settings
                    </a>
                    <a href="" @click.prevent="signout" title="Sign out">
                        <i class="fas fa-sign-out-alt"></i>Sign Out
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['likes', 'username'],
        data: function() {
            return {
                showmenu: false,
            };
        },
        methods: {
            signout() {
                Events.signout();
            },
            toggleMenu() {
                this.showmenu = !this.showmenu;
            }
        }
    }
</script>